/*
 * 移动端滚动性能优化建议：
 *
 * 1. 在 CSS 中添加以下优化：
 *
 * html {
 *   -webkit-overflow-scrolling: touch;
 *   scroll-behavior: smooth;
 * }
 *
 * body {
 *   transform: translateZ(0);
 *   -webkit-transform: translateZ(0);
 * }
 *
 * .animated-element {
 *   will-change: transform, opacity;
 *   transform: translateZ(0);
 *   -webkit-transform: translateZ(0);
 * }
 *
 * 2. 减少重绘和重排：
 * - 使用 transform 而不是改变 top/left
 * - 使用 opacity 而不是 visibility
 * - 避免在滚动时修改 DOM 结构
 */

(function () {
  const gsap = window.gsap;
  window.scrollToTarget = scrollToTarget;
  // 确保GSAP插件已注册
  if (typeof ScrollTrigger !== 'undefined') {
    gsap.registerPlugin(ScrollTrigger);
  }
  // 页面加载完成后初始化
  document.addEventListener('DOMContentLoaded', function () {
    // 移动端DOM元素重排
    initMobileDOMReorder();
    
    // 初始化各个模块
    initBannerAnimations();
    initNavigation();
    initMobileScrollControl();
    initSellingPoints();
    initSellingPointsAnimation();
    initSpecsModal();
    initProductLineup();
    initMaximumPower();
    initGanInfinity();
    initMaximumReliability();
    initElevenLevelProtection();
    initCompatibility();

    // 初始化工具函数
    setupScrollRefresh();
    handleResize();

    console.log('All modules initialized successfully');
  });

  /**
   * 移动端DOM元素重排
   * 在移动端时将指定元素移动到#MainContent的顶部
   */
  function initMobileDOMReorder() {
    const isMobile = window.innerWidth <= 768;
    
    if (isMobile) {
      const mainContent = document.getElementById('MainContent') || document.querySelector('#MainContent');
      
      if (!mainContent) {
        console.warn('MainContent element not found');
        return;
      }

      // 要移动的元素选择器
      const elementsToMove = [
        '.ug-500w-nav-container.mobile-only',
        '.ug-500w-scroll-control'
      ];

      elementsToMove.forEach((selector, index) => {
        const element = document.querySelector(selector);
        
        if (element && !element.classList.contains('moved-to-main')) {
          console.log(`Moving ${selector} to top of MainContent`);
          
          // 保存原始位置信息
          const originalParent = element.parentNode;
          const originalPosition = Array.from(originalParent.children).indexOf(element);
          
          // 存储原始位置信息到元素的dataset中
          element.dataset.originalParent = getElementSelector(originalParent);
          element.dataset.originalPosition = originalPosition.toString();
          
          // 将元素移动到MainContent的最前面
          if (index === 0) {
            // 第一个元素直接插入到最前面
            mainContent.insertBefore(element, mainContent.firstChild);
          } else {
            // 后续元素插入到前一个移动元素的后面
            const previousElement = mainContent.querySelector('.moved-to-main');
            if (previousElement && previousElement.nextSibling) {
              mainContent.insertBefore(element, previousElement.nextSibling);
            } else {
              mainContent.appendChild(element);
            }
          }
          
          // 添加移动标记类，便于CSS样式调整
          element.classList.add('moved-to-main');
        }
      });
    }

    // 监听窗口大小变化，在移动端/桌面端切换时重新排列
    window.addEventListener('resize', debounce(() => {
      const newIsMobile = window.innerWidth <= 768;
      handleDOMReorderOnResize(newIsMobile);
    }, 250));
  }

  /**
   * 获取元素的CSS选择器
   */
  function getElementSelector(element) {
    if (!element || element === document) return '';
    
    if (element.id) {
      return `#${element.id}`;
    }
    
    if (element.className) {
      const classes = element.className.split(' ').filter(cls => cls.trim());
      if (classes.length > 0) {
        return `.${classes.join('.')}`;
      }
    }
    
    return element.tagName.toLowerCase();
  }

  /**
   * 处理窗口大小变化时的DOM重排
   */
  function handleDOMReorderOnResize(isMobile) {
    const elementsToRestore = document.querySelectorAll('.moved-to-main');
    
    if (!isMobile && elementsToRestore.length > 0) {
      // 如果切换到桌面端，恢复元素到原位置
      elementsToRestore.forEach(element => {
        const originalParentSelector = element.dataset.originalParent;
        const originalPosition = parseInt(element.dataset.originalPosition);
        
        if (originalParentSelector) {
          const parentElement = document.querySelector(originalParentSelector);
          if (parentElement) {
            console.log(`Restoring ${getElementSelector(element)} to original position`);
            
            if (!isNaN(originalPosition) && originalPosition >= 0) {
              const referenceElement = parentElement.children[originalPosition];
              if (referenceElement) {
                parentElement.insertBefore(element, referenceElement);
              } else {
                parentElement.appendChild(element);
              }
            } else {
              parentElement.appendChild(element);
            }
          }
        }
        
        element.classList.remove('moved-to-main');
        delete element.dataset.originalParent;
        delete element.dataset.originalPosition;
      });
    } else if (isMobile && elementsToRestore.length === 0) {
      // 如果切换到移动端但元素还未移动，重新执行移动逻辑
      initMobileDOMReorder();
    }
  }

  function initBannerAnimations() {
    // 创建动画时间线
    const bannerTimeline = gsap.timeline({
      defaults: {
        ease: 'power2.out',
        duration: 0.8,
      },
    });

    // 设置初始状态
    gsap.set('.ug-500w-banner-subtitle', { opacity: 0, y: 20 });
    gsap.set('.ug-500w-banner-title', { opacity: 0, y: 30 });
    gsap.set('.ug-500w-banner-desc', { opacity: 0, y: 20 });

    // 执行动画序列
    bannerTimeline
      .to('.ug-500w-banner-subtitle', { opacity: 1, y: 0 })
      .to('.ug-500w-banner-title', { opacity: 1, y: 0 }, '-=0.5')
      .to('.ug-500w-banner-desc', { opacity: 1, y: 0 }, '-=0.3');
  }

  function initNavigation() {
    // 获取所有导航链接
    const navLinks = document.querySelectorAll('.ug-500w-nav-link');

    // 为每个导航链接添加点击事件
    navLinks.forEach((link) => {
      // 跳过specs-modal-btn按钮的处理，让它由SpecsModalModule处理
      if (link.classList.contains('specs-modal-btn')) {
        return;
      }

      link.addEventListener('click', function (e) {
        // 获取目标部分的ID
        const targetId = this.getAttribute('href');
        
        // 如果没有 href 属性，说明是 button，跳过处理
        if (!targetId) return;

        // 对于其他链接，正常处理
        e.preventDefault();

        const targetSection = document.querySelector(targetId);

        // 使用全局辅助函数进行滚动
        if (targetSection) {
          // 直接使用 window.scrollToTarget 函数
          if (
            window.scrollToTarget &&
            typeof window.scrollToTarget === 'function'
          ) {
            console.log(`导航使用全局scrollToTarget滚动到 ${targetId}`);
            window.scrollToTarget(targetId);
          } else {
            // 输出错误信息
            console.error('全局滚动函数不可用，请确保已正确初始化');
          }
        }

        // 更新激活状态（排除specs-modal-btn）
        navLinks.forEach((l) => {
          if (!l.classList.contains('specs-modal-btn')) {
            l.classList.remove('active');
          }
        });
        this.classList.add('active');
      });
    });

    // 处理购买按钮点击事件
    const buyButtons = document.querySelectorAll('.ug-500w-nav-buy-btn');
    buyButtons.forEach((button) => {
      button.addEventListener('click', function () {
        // 这里可以添加购买按钮的功能，例如跳转到购买页面
        console.log('Buy button clicked');
        // window.location.href = 'https://us.ugreen.com/products/nexode-500w';
      });
    });

    // 优化的滚动处理函数
    const handleScroll = function () {
      // 获取各部分的位置，包括top_banner
      const sections = ['#top_banner', '#overview', '#highlight']
        .map((id) => {
          const element = document.querySelector(id);
          return {
            id: id,
            top: element ? element.offsetTop - 100 : 0,
            bottom: element
              ? element.offsetTop + element.offsetHeight - 100
              : 0,
          };
        })
        .filter((section) => section.top >= 0);

      // 获取当前滚动位置
      const scrollPosition = window.scrollY;

      // 特殊处理：如果滚动位置在页面顶部附近，激活Overview链接
      if (scrollPosition < 200) {
        navLinks.forEach((link) => {
          // 跳过specs-modal-btn按钮的处理
          if (link.classList.contains('specs-modal-btn')) {
            return;
          }
          
          if (link.getAttribute('href') === '#top_banner') {
            link.classList.add('active');
          } else {
            link.classList.remove('active');
          }
        });
        return;
      }

      // 找到当前滚动位置所在的部分
      for (const section of sections) {
        if (scrollPosition >= section.top && scrollPosition < section.bottom) {
          // 更新导航链接的激活状态（排除specs-modal-btn）
          navLinks.forEach((link) => {
            // 跳过specs-modal-btn按钮的处理
            if (link.classList.contains('specs-modal-btn')) {
              return;
            }
            
            if (link.getAttribute('href') === section.id) {
              link.classList.add('active');
            } else {
              link.classList.remove('active');
            }
          });
          break;
        }
      }
    };

    // 使用更短的节流时间，提高响应性
    const throttledScrollHandler = throttle(handleScroll, 100); // 从50ms增加到100ms

    // 处理滚动时导航链接的激活状态
    window.addEventListener('scroll', throttledScrollHandler, {
      passive: true,
    }); // 添加 passive 选项
  }

  function initMobileScrollControl() {
    const scrollControl = document.querySelector('.ug-500w-scroll-control');
    const scrollLinks = document.querySelectorAll('.ug-500w-scroll-link');

    if (!scrollControl) return;

    const showThreshold = window.innerHeight * 0.02; // 2vh

    // 简化的滚动处理函数
    const handleScroll = function () {
      const currentScrollTop = window.scrollY;
      const footer = document.getElementById('shopify-section-footer');
      
      // 检查是否应该显示控制条
      let shouldShow = currentScrollTop > showThreshold;
      
      // 如果 footer 存在且顶部进入视口，则隐藏
      if (footer && shouldShow) {
        const footerRect = footer.getBoundingClientRect();
        if (footerRect.top <= 0) {
          shouldShow = false;
        }
      }

      // 更新显示状态
      if (shouldShow) {
        scrollControl.classList.add('show');
        scrollControl.classList.remove('hide');
      } else {
        scrollControl.classList.remove('show');
        scrollControl.classList.add('hide');
      }
    };

    // 使用节流优化性能，减少执行频率
    const throttledScrollHandler = throttle(handleScroll, 100);

    // 监听滚动事件
    window.addEventListener('scroll', throttledScrollHandler);

    // 独立处理链接激活状态更新，使用更低频率的节流
    const updateActiveLink = throttle(updateScrollControlActiveLink, 200);
    window.addEventListener('scroll', updateActiveLink);

    // 初始检查
    handleScroll();
    updateScrollControlActiveLink();

    // 为滚动控制条上的链接添加点击事件（排除specs-modal-btn）
    scrollLinks.forEach((link) => {
      // 跳过specs-modal-btn按钮的处理，让它由SpecsModalModule处理
      if (link.classList.contains('specs-modal-btn')) {
        return;
      }

      link.addEventListener('click', function (e) {
        // 获取目标部分的ID
        const targetId = this.getAttribute('href');

        // 如果没有 href 属性，说明是 button，跳过处理
        if (!targetId) return;

        // 对于其他链接，正常处理
        e.preventDefault();

        const targetSection = document.querySelector(targetId);

        // 使用全局辅助函数进行滚动
        if (targetSection) {
          // 直接使用 window.scrollToTarget 函数
          if (
            window.scrollToTarget &&
            typeof window.scrollToTarget === 'function'
          ) {
            console.log(`滚动控制条使用全局scrollToTarget滚动到 ${targetId}`);
            window.scrollToTarget(targetId);
          } else {
            // 输出错误信息
            console.error('全局滚动函数不可用，请确保已正确初始化');
          }
        }

        // 更新激活状态（排除specs-modal-btn）
        scrollLinks.forEach((l) => {
          if (!l.classList.contains('specs-modal-btn')) {
            l.classList.remove('active');
          }
        });
        this.classList.add('active');
      });
    });
  }

  /**
   * 更新滚动控制条上的链接激活状态
   */
  function updateScrollControlActiveLink() {
    const scrollLinks = document.querySelectorAll('.ug-500w-scroll-link');

    // 获取各部分的位置，包括top_banner，但排除specifications（现在是弹窗触发器）
    const sections = ['#top_banner', '#overview', '#highlight']
      .map((id) => {
        const element = document.querySelector(id);
        return {
          id: id,
          top: element ? element.offsetTop - 100 : 0,
          bottom: element ? element.offsetTop + element.offsetHeight - 100 : 0,
        };
      })
      .filter((section) => section.top >= 0);

    // 获取当前滚动位置
    const scrollPosition = window.scrollY;

    // 特殊处理：如果滚动位置在页面顶部附近，激活Overview链接
    if (scrollPosition < 200) {
      scrollLinks.forEach((link) => {
        // 跳过specs-modal-btn按钮的处理
        if (link.classList.contains('specs-modal-btn')) {
          return;
        }
        
        if (link.getAttribute('href') === '#top_banner') {
          link.classList.add('active');
        } else {
          link.classList.remove('active');
        }
      });
      return;
    }

    // 找到当前滚动位置所在的部分
    for (const section of sections) {
      if (scrollPosition >= section.top && scrollPosition < section.bottom) {
        // 更新导航链接的激活状态（排除specs-modal-btn）
        scrollLinks.forEach((link) => {
          // 跳过specs-modal-btn按钮的处理
          if (link.classList.contains('specs-modal-btn')) {
            return;
          }
          
          if (link.getAttribute('href') === section.id) {
            link.classList.add('active');
          } else {
            link.classList.remove('active');
          }
        });
        break;
      }
    }
  }

  class SellingPointsModule {
    constructor() {
      this.container = document.querySelector(
        '.ug-500w-selling-points-container'
      );
      this.cards = document.querySelectorAll('.ug-500w-selling-point-card');
      this.isMobile = window.innerWidth <= 768;

      this.init();
    }

    init() {
      if (!this.container) return;

      this.setupScrollAnimations();
      this.setupHoverEffects();
      this.setupResponsiveHandling();
    }

    setupScrollAnimations() {
      // 检查是否有 GSAP 和 ScrollTrigger
      if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
        console.warn('GSAP or ScrollTrigger not loaded, skipping animations');
        return;
      }

      // 注册 ScrollTrigger 插件
      gsap.registerPlugin(ScrollTrigger);

      // 移动端简化动画，减少性能消耗
      if (this.isMobile) {
        // 移动端只做简单的淡入动画
        gsap.fromTo(
          this.container,
          {
            opacity: 0,
            y: 30,
          },
          {
            opacity: 1,
            y: 0,
            duration: 0.6,
            ease: 'power2.out',
            scrollTrigger: {
              trigger: this.container,
              start: 'top 85%',
              toggleActions: 'play none none none',
            },
          }
        );

        // 卡片简单淡入
        gsap.fromTo(
          this.cards,
          {
            opacity: 0,
            y: 20,
          },
          {
            opacity: 1,
            y: 0,
            duration: 0.6,
            stagger: 0.1,
            ease: 'power2.out',
            scrollTrigger: {
              trigger: this.container,
              start: 'top 80%',
              toggleActions: 'play none none none',
            },
          }
        );
        return;
      }

      // 桌面端保持原有复杂动画
      // 容器进入动画 - 提前触发时机
      gsap.fromTo(
        this.container,
        {
          opacity: 0,
          y: 100,
        },
        {
          opacity: 1,
          y: 0,
          duration: 1,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: this.container,
            start: 'top 90%', // 从80%提前到90%
            end: 'top 60%', // 从50%调整到60%
            toggleActions: 'play none none reverse',
          },
        }
      );

      // 卡片逐个出现动画 - 提前触发时机
      this.cards.forEach((card, index) => {
        gsap.fromTo(
          card,
          {
            opacity: 0,
            y: 50,
            scale: 0.9,
          },
          {
            opacity: 1,
            y: 0,
            scale: 1,
            duration: 0.8,
            ease: 'power2.out',
            delay: index * 0.08, // 从0.1减少到0.08，加快连续动画
            scrollTrigger: {
              trigger: card,
              start: 'top 95%', // 从85%提前到95%
              end: 'top 70%', // 从60%调整到70%
              toggleActions: 'play none none reverse',
            },
          }
        );

        // 卡片内容动画 - 提前触发时机
        const content = card.querySelector('.ug-500w-selling-point-content');
        const icon = card.querySelector('.ug-500w-selling-point-icon');

        if (content) {
          gsap.fromTo(
            content,
            {
              opacity: 0,
              y: 20,
            },
            {
              opacity: 1,
              y: 0,
              duration: 0.6,
              ease: 'power2.out',
              delay: index * 0.08 + 0.2, // 调整延迟时间
              scrollTrigger: {
                trigger: card,
                start: 'top 90%', // 从80%提前到90%
                end: 'top 65%', // 从55%调整到65%
                toggleActions: 'play none none reverse',
              },
            }
          );
        }

        if (icon) {
          gsap.fromTo(
            icon,
            {
              opacity: 0,
              scale: 0,
              rotation: -180,
            },
            {
              opacity: 0.9,
              scale: 1,
              rotation: 0,
              duration: 0.5,
              ease: 'back.out(1.7)',
              delay: index * 0.08 + 0.4, // 调整延迟时间
              scrollTrigger: {
                trigger: card,
                start: 'top 85%', // 从75%提前到85%
                end: 'top 60%', // 从50%调整到60%
                toggleActions: 'play none none reverse',
              },
            }
          );
        }
      });

      // 特殊动画：保护卡片的叠加图片 - 提前触发时机
      const protectionCard = document.querySelector(
        '.ug-500w-selling-point-protection'
      );
      if (protectionCard) {
        const overlay = protectionCard.querySelector('.protection-overlay');
        if (overlay) {
          gsap.fromTo(
            overlay,
            {
              opacity: 0,
              scale: 0.8,
              rotation: 10,
            },
            {
              opacity: 1,
              scale: 1,
              rotation: 0,
              duration: 1,
              ease: 'power2.out',
              delay: 0.6, // 从0.8减少到0.6
              scrollTrigger: {
                trigger: protectionCard,
                start: 'top 80%', // 从70%提前到80%
                end: 'top 50%', // 从40%调整到50%
                toggleActions: 'play none none reverse',
              },
            }
          );
        }
      }
    }

    setupHoverEffects() {
      this.cards.forEach((card) => {
        const bg = card.querySelector('.ug-500w-selling-point-bg');
        const content = card.querySelector('.ug-500w-selling-point-content');
        const icon = card.querySelector('.ug-500w-selling-point-icon');

        // PC端3D跟随效果
        if (!this.isMobile) {
          this.setup3DHoverEffect(card);
        }

        // 点击效果
        card.addEventListener('click', () => {
          // 点击波纹效果
          gsap.to(card, {
            scale: 0.98,
            duration: 0.1,
            ease: 'power2.out',
            yoyo: true,
            repeat: 1,
          });

          // 跳转到对应区域
          this.handleCardClick(card);
        });
      });
    }

    setup3DHoverEffect(card) {
      // 设置3D透视
      card.style.transformStyle = 'preserve-3d';

      // 获取 circle-icon 中的 SVG 元素
      const circleIcon = card.querySelector('.circle-icon');
      let hoverAnimation = null; // 用于存储循环动画的引用

      card.addEventListener('mouseenter', () => {
        // 开始 SVG 的循环向下位移动画
        if (circleIcon) {
          hoverAnimation = gsap.to(circleIcon, {
            y: 8, // 向下移动8px
            duration: 0.8,
            ease: 'power2.inOut',
            repeat: -1, // 无限循环
            yoyo: true, // 来回运动
          });
        }
      });

      card.addEventListener('mousemove', (e) => {
        const rect = card.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        const centerX = rect.width / 2;
        const centerY = rect.height / 2;

        // 计算旋转角度（最大15度）
        const maxRotate = 15;
        const rotateY = ((x - centerX) / centerX) * maxRotate;
        const rotateX = -((y - centerY) / centerY) * maxRotate;

        // 计算Z轴位移（鼠标越靠近中心，卡片越突出）
        const distance = Math.sqrt(
          Math.pow(x - centerX, 2) + Math.pow(y - centerY, 2)
        );
        const maxDistance = Math.sqrt(
          Math.pow(centerX, 2) + Math.pow(centerY, 2)
        );
        const translateZ = (1 - distance / maxDistance) * 20;

        // 应用3D变换 - 使用CSS变量和perspective
        card.style.setProperty('--rx', `${rotateX}deg`);
        card.style.setProperty('--ry', `${rotateY}deg`);

        gsap.to(card, {
          duration: 0.3,
          ease: 'power2.out',
          transform: `perspective(1000px) rotateX(var(--rx, 0deg)) rotateY(var(--ry, 0deg))`
        });

        // 背景图片反向移动效果
        const img = card.querySelector('.img-placeholder img');
        if (img) {
          gsap.to(img, {
            duration: 0.3,
            ease: 'power2.out',
            x: -rotateY * 0.5,
            y: rotateX * 0.5,
            scale: 1.1,
          });
        }

        // 内容轻微浮动
        const content = card.querySelector('.ug-500w-selling-point-content');
        if (content) {
          gsap.to(content, {
            duration: 0.3,
            ease: 'power2.out',
            z: 10,
            y: -2,
          });
        }
      });

      card.addEventListener('mouseleave', () => {
        // 停止 SVG 的循环动画并恢复原位
        if (hoverAnimation) {
          hoverAnimation.kill(); // 停止循环动画
          hoverAnimation = null;
        }
        if (circleIcon) {
          gsap.to(circleIcon, {
            y: 0, // 恢复原位
            duration: 0.3,
            ease: 'power2.out',
          });
        }

        // 恢复原状 - 重置CSS变量
        card.style.setProperty('--rx', '0deg');
        card.style.setProperty('--ry', '0deg');

        gsap.to(card, {
          duration: 0.5,
          ease: 'power2.out',
          transform: 'perspective(1000px) rotateX(0deg) rotateY(0deg)',
          boxShadow: '0 2px 24px 0 rgba(0, 0, 0, 0.1)',
        });

        // 恢复背景图片
        const img = card.querySelector('.img-placeholder img');
        if (img) {
          gsap.to(img, {
            duration: 0.5,
            ease: 'power2.out',
            x: 0,
            y: 0,
            scale: 1,
          });
        }

        // 恢复内容位置
        const content = card.querySelector('.ug-500w-selling-point-content');
        if (content) {
          gsap.to(content, {
            duration: 0.5,
            ease: 'power2.out',
            z: 0,
            y: 0,
          });
        }
      });
    }

    handleCardClick(card) {
      // 获取目标区域ID
      const targetId = card.getAttribute('data-target');

      if (targetId) {
        // 如果targetId不以#开头，则添加#
        const selector = targetId.startsWith('#') ? targetId : `#${targetId}`;

        // 查找目标元素
        const targetElement = document.querySelector(selector);

        if (targetElement) {
          // 获取目标元素的位置
          const rect = targetElement.getBoundingClientRect();
          const targetPosition = window.pageYOffset + rect.top;

          // 先尝试停止任何正在进行的滚动
          if (typeof gsap !== 'undefined') {
            gsap.killTweensOf(window);
          }

          // 使用自定义的平滑滚动函数
          this.smoothScrollTo(targetPosition - 80);

          console.log(`Scrolling to ${selector} at position ${targetPosition}`);
        } else {
          // 如果目标元素不存在，输出提示信息
          console.warn(
            `Target element ${selector} not found. Please add this section to the page.`
          );

          // 可以在这里添加临时的占位符跳转，比如跳转到页面底部
          const targetPosition = document.body.scrollHeight;
          this.smoothScrollTo(targetPosition);
        }
      } else {
        console.warn('No data-target attribute found on card');
      }
    }

    // 自定义平滑滚动函数
    smoothScrollTo(targetY) {
      const startY = window.pageYOffset;
      const distance = targetY - startY;
      const duration = 1000; // 1秒
      let startTime = null;

      function easeInOutCubic(t) {
        return t < 0.5
          ? 4 * t * t * t
          : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
      }

      function animation(currentTime) {
        if (startTime === null) startTime = currentTime;
        const timeElapsed = currentTime - startTime;
        const progress = Math.min(timeElapsed / duration, 1);

        const ease = easeInOutCubic(progress);
        window.scrollTo(0, startY + distance * ease);

        if (progress < 1) {
          requestAnimationFrame(animation);
        }
      }

      requestAnimationFrame(animation);
    }

    getCardType(card) {
      const classList = card.classList;
      if (classList.contains('ug-500w-selling-point-single-port'))
        return 'single-port';
      if (classList.contains('ug-500w-selling-point-power-output'))
        return 'power-output';
      if (classList.contains('ug-500w-selling-point-6-devices'))
        return '6-devices';
      if (classList.contains('ug-500w-selling-point-gan-chips'))
        return 'gan-chips';
      if (classList.contains('ug-500w-selling-point-5-laptops'))
        return '5-laptops';
      if (classList.contains('ug-500w-selling-point-protection'))
        return 'protection';
      if (classList.contains('ug-500w-selling-point-ntc')) return 'ntc';
      if (classList.contains('ug-500w-selling-point-compatibility'))
        return 'compatibility';
      return 'unknown';
    }

    setupResponsiveHandling() {
      // 监听窗口大小变化
      window.addEventListener('resize', () => {
        const newIsMobile = window.innerWidth <= 768;
        if (newIsMobile !== this.isMobile) {
          this.isMobile = newIsMobile;
          this.refreshAnimations();
        }
      });
    }

    refreshAnimations() {
      // 刷新 ScrollTrigger
      if (typeof ScrollTrigger !== 'undefined') {
        ScrollTrigger.refresh();
      }
    }

    // 公共方法：重新初始化模块
    reinit() {
      this.init();
    }

    // 公共方法：销毁模块
    destroy() {
      // 移除事件监听器
      this.cards.forEach((card) => {
        card.removeEventListener('mouseenter', () => {});
        card.removeEventListener('mouseleave', () => {});
        card.removeEventListener('click', () => {});
      });

      // 清除 GSAP 动画
      if (typeof gsap !== 'undefined') {
        gsap.killTweensOf(this.container);
        gsap.killTweensOf(this.cards);
      }

      // 清除 ScrollTrigger
      if (typeof ScrollTrigger !== 'undefined') {
        ScrollTrigger.getAll().forEach((trigger) => {
          if (
            trigger.trigger === this.container ||
            Array.from(this.cards).includes(trigger.trigger)
          ) {
            trigger.kill();
          }
        });
      }
    }
  }

  // 模块实例
  let sellingPointsInstance = null;

  // 初始化函数
  function initSellingPoints() {
    if (!sellingPointsInstance) {
      sellingPointsInstance = new SellingPointsModule();
      window.sellingPointsModule = sellingPointsInstance;
    }
    return sellingPointsInstance;
  }

  // 动画初始化函数（为了兼容现有的main.js）
  function initSellingPointsAnimation() {
    // 这个函数现在由initSellingPoints处理，保留为空函数以避免错误
    return;
  }

  // 滚动到目标函数（为了兼容现有的main.js）
  function scrollToTarget(target) {
    // 确保target是一个有效的选择器或元素
    let targetElement;

    if (typeof target === 'string') {
      // 如果是字符串，查找对应的元素
      targetElement = document.querySelector(target);
    } else if (target instanceof Element) {
      // 如果已经是元素，直接使用
      targetElement = target;
    }

    if (targetElement) {
      // 获取目标元素的位置
      const rect = targetElement.getBoundingClientRect();
      const targetPosition = window.pageYOffset + rect.top - 80; // 添加偏移量，避免被导航栏遮挡

      // 使用自定义的平滑滚动函数，不依赖GSAP ScrollTo插件
      smoothScrollToPosition(targetPosition);
    } else {
      console.warn(`Target element not found: ${target}`);
    }
  }

  // 将滚动函数暴露到全局作用域
  window.scrollToTarget = scrollToTarget;
  // 自定义平滑滚动函数（不依赖GSAP ScrollTo插件）
  function smoothScrollToPosition(targetY) {
    const startY = window.pageYOffset;
    const distance = targetY - startY;
    const duration = 1000; // 1秒
    let startTime = null;

    function easeInOutCubic(t) {
      return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
    }

    function animation(currentTime) {
      if (startTime === null) startTime = currentTime;
      const timeElapsed = currentTime - startTime;
      const progress = Math.min(timeElapsed / duration, 1);

      const ease = easeInOutCubic(progress);
      window.scrollTo(0, startY + distance * ease);

      if (progress < 1) {
        requestAnimationFrame(animation);
      }
    }

    requestAnimationFrame(animation);
  }

  class SpecsModalModule {
    constructor() {
      this.modal = document.getElementById('specs-modal-overlay');
      this.closeBtn = document.getElementById('specs-modal-close');
      this.logo = document.querySelectorAll('.ug-500w-nav-title');
      this.navLinks = document.querySelectorAll('.ug-500w-nav-link');
      this.scrollLinks = document.querySelectorAll('.ug-500w-scroll-link');
      this.specsLinks = [];
      this.isOpen = false;
      this.scrollPosition = null; // 保存滚动位置
      this.specsContainer = document.getElementById('specs-overview-container');
      this.specsPlaceholder = document.getElementById(
        'specs-content-placeholder'
      );
      this.originalParent = null;

      // 产品规格相关的属性
      this.selectedProducts = [0, 1, 2]; // 默认选择前三个产品
      this.icons = this.initIcons();
      this.products = this.initProducts();

      this.init();
    }

    initIcons() {
      return {
        fastCharging: `<svg width="39" height="34" viewBox="0 0 39 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.66406 32.6775V5.67746C1.66406 3.46832 3.45492 1.67746 5.66406 1.67746H33.6641C35.8732 1.67746 37.6641 3.46832 37.6641 5.67746V32.6775" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M10.6641 7.82746C10.6641 6.53746 11.5241 5.67746 12.8141 5.67746H25.7141C27.0041 5.67746 27.8641 6.53746 27.8641 7.82746C27.8641 9.11746 27.0041 9.97746 25.7141 9.97746H12.8141C11.5241 9.97746 10.6641 9.11746 10.6641 7.82746ZM27.0041 7.82746C27.0041 8.68746 26.5741 9.11746 25.7141 9.11746C24.8541 9.11746 24.4241 8.68746 24.4241 7.82746C24.4241 6.96746 24.8541 6.53746 25.7141 6.53746C26.5741 6.53746 27.0041 6.96746 27.0041 7.82746Z" fill="currentColor"/>
            </svg>`,

        usbC: `<svg width="56" height="21" viewBox="0 0 56 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="9.16406" y="8.67737" width="37" height="4" rx="2" fill="currentColor"/>
                <rect x="1.16406" y="1.67737" width="53" height="18" rx="9" stroke="currentColor" stroke-width="2"/>
            </svg>`,

        laptop: `<svg width="57" height="35" viewBox="0 0 57 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.66406 32.6775V3.67746C5.66406 2.57289 6.55949 1.67746 7.66406 1.67746H49.6641C50.7686 1.67746 51.6641 2.57289 51.6641 3.67746V32.6775" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M22.6641 1.67746H34.6641L33.8125 4.0192C33.6688 4.41439 33.2932 4.67746 32.8727 4.67746H24.4554C24.0349 4.67746 23.6593 4.41439 23.5156 4.0192L22.6641 1.67746Z" fill="currentColor"/>
                <path d="M28.6641 33.6775H5.52121L1.66406 32.6775H55.6641L51.8069 33.6775H28.6641Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>`,

        output: `<svg width="57" height="31" viewBox="0 0 57 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M25.0696 24.4054L29.6641 13.4054H25.0696V5.40543L20.6641 16.4054H25.0696V24.4054Z" fill="currentColor"/>
                <path d="M56.6641 17.9502L56.6641 12.8593C56.6641 10.3138 52.8382 10.3138 52.8382 10.2375L52.8382 20.4956C52.8382 20.4956 56.6641 20.4956 56.6641 17.9502Z" fill="currentColor"/>
                <path d="M46.2141 0.13199L6.02135 0.131988C0.706448 0.131988 0.663177 5.68617 0.663177 5.68617L0.663176 25.1233C0.663176 25.1233 0.663172 30.6774 6.02135 30.6774L46.2141 30.6774C51.5723 30.6774 51.5723 25.1233 51.5723 25.1233L51.5723 5.68617C51.5723 5.68617 51.5723 0.13199 46.2141 0.13199ZM49.0268 25.304C49.0268 25.304 49.0268 28.132 46.3312 28.132L5.90427 28.132C3.20863 28.132 3.20863 25.304 3.20863 25.304L3.20863 5.50544C3.20863 5.50544 3.20863 2.67744 5.90427 2.67744L46.3312 2.67744C49.1108 2.67744 49.0268 5.50545 49.0268 5.50545L49.0268 25.304Z" fill="currentColor"/>
            </svg>`,

        dropdown: `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.799805 5.6001L7.9998 12.8001L15.1998 5.6001" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>`,
      };
    }

    initProducts() {
      const icons = this.icons; // 获取图标引用
      
      // 基本安全检查
      if (!window.UG_500W_PRODUCT_INFO || !Array.isArray(window.UG_500W_PRODUCT_INFO) || window.UG_500W_PRODUCT_INFO.length < 3) {
        console.error('UG_500W_PRODUCT_INFO is not properly defined. Please check the liquid template.');
        // 返回最小化的默认数据以避免崩溃
        return [
          { id: 1, name: 'Product 1', shortName: '500W', image: '', href: '#', specs: {} },
          { id: 2, name: 'Product 2', shortName: '200W', image: '', href: '#', specs: {} },
          { id: 3, name: 'Product 3', shortName: '100W', image: '', href: '#', specs: {} }
        ];
      }
      
      return [
        {
          id: 1,
          name: 'Nexode 500W',
          shortName: '500W',
          image: window.UG_500W_PRODUCT_INFO[0]['product_image'],
          href: window.UG_500W_PRODUCT_INFO[0]['product_url'],
          specs: {
            totalOutput: {
              icon: null,
              title: 'Total Output Power',
              value: '500W',
            },
            singleOutput: {
              icon: icons.output,
              title: 'Single USB-C Output（Max）',
              value: '240W',
            },
            ports: {
              icon: null,
              title: 'Ports and Connections',
              value: '5 USB-C+1 USB A',
            },
            fastCharging: {
              icon: icons.fastCharging,
              value: 'Supports iPhone/Samsung Fast charging',
            },
            laptopCompatible: {
              icon: icons.laptop,
              value: 'Supports iPhone/Samsung Fast charging',
            },
            input: {
              icon: null,
              title: 'Input',
              value: '100-240V~ 50/60Hz 7.0A Max',
            },
            usbC1: {
              icon: icons.usbC,
              title: 'USB-C1 Output',
              value:
                '5.0V=3.0A/9.0V=3.0A/12.0V=3.0A/15.0V=3.0A/20.0V=5.0A/28.0V⎓5.0A/36.0V⎓5.0A/48.0V⎓5.0A 240.0W Max',
            },
            usbC2: {
              icon: icons.usbC,
              title: 'USB-C2 Output',
              value:
                '5.0V=3.0A/9.0V=3.0A/12.0V=3.0A/15.0V=3.0A/20.0V=5.0A 100.0W Max',
            },
            usbC3: {
              icon: icons.usbC,
              title: 'USB-C3 Output',
              value:
                '5.0V=3.0A/9.0V=3.0A/12.0V=3.0A/15.0V=3.0A/20.0V=5.0A 100.0W Max',
            },
            usbC4: {
              icon: icons.usbC,
              title: 'USB-C4 Output',
              value:
                '5.0V=3.0A/9.0V=3.0A/12.0V=3.0A/15.0V=3.0A/20.0V=5.0A 100.0W Max',
            },
            usbC5: {
              icon: icons.usbC,
              title: 'USB-C5 Output',
              value:
                '5.0V=3.0A/9.0V=3.0A/12.0V=3.0A/15.0V=3.0A/20.0V=5.0A 100.0W Max',
            },
            usbA: {
              icon: null,
              title: 'USB-A Output',
              value: '5.0V=3.0A/9.0V=2.0A /12.0V=1.5A /10.0V=2.25A 20W Max',
            },
            size: {
              icon: null,
              title: 'Size',
              value: '146 × 114.6 × 60.6 mm',
            },
            weight: {
              icon: null,
              title: 'Weight',
              value: '2175 g',
            },
          },
        },
        {
          id: 2,
          name: 'Nexode 200W',
          shortName: '200W',
          image: window.UG_500W_PRODUCT_INFO[1]['product_image'],
          href: window.UG_500W_PRODUCT_INFO[1]['product_url'],
          specs: {
            totalOutput: {
              icon: null,
              title: 'Total Output Power',
              value: '200W',
            },
            singleOutput: {
              icon: icons.output,
              title: 'Single USB-C Output（Max）',
              value: '140W',
            },
            ports: {
              icon: null,
              title: 'Ports and Connections',
              value: '3 USB-C+1 USB A',
            },
            fastCharging: {
              icon: icons.fastCharging,
              value: 'Supports iPhone/Samsung Fast charging',
            },
            laptopCompatible: {
              icon: icons.laptop,
              value: 'Supports iPhone/Samsung Fast charging',
            },
            input: {
              icon: null,
              title: 'Input',
              value: '100-240V～50/60Hz 3.0A Max',
            },
            usbC1: {
              icon: icons.usbC,
              title: 'USB-C1 Output',
              value:
                '5.0V=3.0A/9.0V=3.0A/12.0V=3.0A/15.0V=3.0A/20.0V=5.0A /28.0V=5.0A 140.0W Max',
            },
            usbC2: {
              icon: icons.usbC,
              title: 'USB-C2 Output',
              value:
                '5.0V=3.0A/9.0V=3.0A/12.0V=3.0A/15.0V=3.0A/20.0V=5.0A 100.0W Max',
            },
            usbC3: {
              icon: icons.usbC,
              title: 'USB-C3 Output',
              value: '5V=3A/9.0V=3.0A/12.0V/2.5.0A 30.0W Max',
            },
            usbC4: null,
            usbC5: null,
            usbA: {
              icon: null,
              title: 'USB-A Output',
              value: '5.0V=3.0A/9.0V=3.0A/12.0V=1.5A/10.0V=2.25A 22.5W',
            },
            size: {
              icon: null,
              title: 'Size',
              value: '76 × 76 × 36 mm',
            },
            weight: {
              icon: null,
              title: 'Weight',
              value: '259 g',
            },
          },
        },
        {
          id: 3,
          name: 'Nexode 100W',
          shortName: '100W',
          image: window.UG_500W_PRODUCT_INFO[2]['product_image'],
          href: window.UG_500W_PRODUCT_INFO[2]['product_url'],
          specs: {
            totalOutput: {
              icon: null,
              title: 'Total Output Power',
              value: '100W',
            },
            singleOutput: {
              icon: icons.output,
              title: 'Single USB-C Output（Max）',
              value: '100W',
            },
            ports: {
              icon: null,
              title: 'Ports and Connections',
              value: '4 USB-C+1 USB A',
            },
            fastCharging: {
              icon: icons.fastCharging,
              value: 'Supports iPhone/Samsung Fast charging',
            },
            laptopCompatible: {
              icon: icons.laptop,
              value: 'Supports iPhone/Samsung Fast charging',
            },
            input: {
              icon: null,
              title: 'Input',
              value: '100-240V～50/60Hz 1.8A Max',
            },
            usbC1: {
              icon: icons.usbC,
              title: 'USB-C1 Output',
              value:
                '5.0V=3.0A/9.0V=3,0A/12.0V=3.0A/15.0V=3.0A/20.0V=5.0A 100.0W Max',
            },
            usbC2: {
              icon: icons.usbC,
              title: 'USB-C2 Output',
              value:
                '5.0V=3.0A/9.0V=3.0A/12.0V=3.0A/15.0V=3.0A/20.0V=5.0A 100.0W Max',
            },
            usbC3: {
              icon: icons.usbC,
              title: 'USB-C3 Output',
              value:
                '5.0V=3.0A/9.0V=3.0A/12.0V=3.0A/15.0V=3.0A/20.0V=5.0A 100W Max',
            },
            usbC4: {
              icon: icons.usbC,
              title: 'USB-C4 Output',
              value:
                '5.0V=3.0A/9.0V=3.0A/12.0V=3.0A /15.0V=3.0A/20.0V=2.25A 45.0W Max',
            },
            usbC5: null,
            usbA: {
              icon: null,
              title: 'USB-A Output',
              value: '5.0V=3.0A/9.0V=2.0A/12.0V=1.5A/10.0V=2.25A 22.5W Max',
            },
            size: {
              icon: null,
              title: 'Size',
              value: '69 × 69 × 33.5 mm',
            },
            weight: {
              icon: null,
              title: 'Weight',
              value: '384 g',
            },
          },
        },
      ];
    }

    init() {
      console.log('SpecsModalModule: Initializing...', {
        modal: !!this.modal,
        specsContainer: !!this.specsContainer,
        modalId: this.modal ? this.modal.id : 'not found'
      });

      if (!this.modal) {
        console.warn('Specs modal not found');
        return;
      }

      if (!this.specsContainer) {
        console.warn('Specs container not found');
        return;
      }

      // 记录原始父元素
      this.originalParent = this.specsContainer.parentNode;

      this.findSpecsLink();
      this.setupEventListeners();
    }

    findSpecsLink() {
      // 查找所有 specs-modal-btn 按钮
      const specsButtons = document.querySelectorAll('.specs-modal-btn');
      console.log('SpecsModalModule: Found specs buttons:', specsButtons.length, specsButtons);
      
      specsButtons.forEach((button) => {
        this.specsLinks.push(button);
      });
      
      console.log('SpecsModalModule: Total specsLinks:', this.specsLinks.length);
    }

    setupEventListeners() {
      console.log('SpecsModalModule: Setting up event listeners for', this.specsLinks.length, 'specs buttons');
      
      // Specifications链接点击事件
      if (this.specsLinks.length > 0) {
        this.specsLinks.forEach((link, index) => {
          console.log(`SpecsModalModule: Adding click listener to button ${index}:`, link);
          link.addEventListener('click', (e) => {
            console.log('SpecsModalModule: Specs button clicked!', e.target);
            e.preventDefault();
            e.stopPropagation(); // 阻止事件冒泡
            this.openModal();
          });
        });
      } else {
        console.warn('SpecsModalModule: No specs buttons found to bind events!');
      }

      // 关闭按钮点击事件
      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', () => {
          this.closeModal();
        });
      }

      if (this.logo) {
        this.logo.forEach((logo) => {
          logo.addEventListener('click', () => {
            this.closeModal();
          });
        });
      }

      // 遮罩层点击事件（点击背景关闭）
      this.modal.addEventListener('click', (e) => {
        if (e.target === this.modal) {
          this.closeModal();
        }
      });

      // ESC键关闭
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen) {
          this.closeModal();
        }
      });

      // 其他导航链接点击事件（关闭弹窗）
      this.navLinks.forEach((link) => {
        if (!this.specsLinks.includes(link)) {
          link.addEventListener('click', () => {
            if (this.isOpen) {
              this.closeModal();
            }
          });
        }
      });

      // 其他移动端scroll链接点击事件（关闭弹窗）
      this.scrollLinks.forEach((link) => {
        if (!this.specsLinks.includes(link)) {
          link.addEventListener('click', () => {
            if (this.isOpen) {
              this.closeModal();
            }
          });
        }
      });

      // 监听窗口大小变化
      window.addEventListener('resize', () => {
        if (this.isOpen) {
          this.adjustModalPosition();
        }
      });
    }

    openModal() {
      if (this.isOpen) return;

      this.isOpen = true;

      // 保存当前滚动位置
      this.scrollPosition = window.pageYOffset;

      // 将specs容器移动到弹窗中
      if (this.specsContainer && this.specsPlaceholder) {
        this.specsPlaceholder.appendChild(this.specsContainer);
      }

      // 显示弹窗
      this.modal.style.display = 'block';

      // 防止背景滚动，同时保持滚动位置
      document.body.style.position = 'fixed';
      document.body.style.top = `-${this.scrollPosition}px`;
      document.body.style.width = '100%';
      document.body.classList.add('modal-open');

      // 添加显示动画
      requestAnimationFrame(() => {
        this.modal.classList.add('show');
        this.modal.classList.remove('hide');
      });

      // 初始化产品规格内容
      this.initSpecsContent();

      // 更新导航状态
      this.updateNavState('specifications');

      console.log('Specs modal opened');
    }

    initSpecsContent() {
      // 初始化产品规格的渲染
      this.renderAll();

      // 添加窗口大小变化监听
      this.handleResize = this.debounce(() => {
        this.renderAll();
      }, 250);

      window.addEventListener('resize', this.handleResize);
    }

    // 渲染产品选择器
    renderProductSelector() {
      const container = document.getElementById('product-selector');
      if (!container) return;

      // 根据屏幕尺寸决定显示的产品数量
      const isMobile = window.innerWidth < 768;
      const displayProducts = isMobile
        ? this.selectedProducts.slice(0, 2)
        : this.selectedProducts;

      container.innerHTML = displayProducts
        .map((productIndex, index) => {
          const product = this.products[productIndex];
          return `
                    <div class="flex-1 min-w-0">
                        <div class="product-selector-item selected" data-index="${index}">
                            <select class="w-full bg-transparent border-none outline-none text-white font-semibold text-sm md:text-base pr-8 cursor-pointer appearance-none" data-product-index="${index}">
                                ${this.products
                                  .map(
                                    (p, i) => `
                                        <option value="${i}" ${
                                      i === productIndex ? 'selected' : ''
                                    } class="text-black">
                                            ${p.name}
                                        </option>
                                    `
                                  )
                                  .join('')}
                            </select>
                            <div class="dropdown-arrow">
                                ${this.icons.dropdown}
                            </div>
                        </div>
                    </div>
                `;
        })
        .join('');

      // 添加选择器事件监听
      container.querySelectorAll('select').forEach((select) => {
        select.addEventListener('change', (e) => {
          const index = parseInt(e.target.dataset.productIndex);
          const newProductIndex = parseInt(e.target.value);
          this.selectedProducts[index] = newProductIndex;
          this.renderAll();
        });
      });
    }

    // 渲染产品图片
    renderProductImages() {
      const container = document.getElementById('product-images');
      if (!container) return;

      // 根据屏幕尺寸决定显示的产品数量
      const isMobile = window.innerWidth < 768;
      const displayProducts = isMobile
        ? this.selectedProducts.slice(0, 2)
        : this.selectedProducts;

      container.innerHTML = displayProducts
        .map((productIndex, index) => {
          const product = this.products[productIndex];
          const isFirst = index === 0;
          return `
                    <div class="flex-1 min-w-0 flex flex-col items-center justify-center">
                        <div class="product-image-container">
                        <div class="product-image-container-inner h-[160px] max-h-[164px]">
                            <img src="${product.image}" alt="${
            product.name
          }" class="max-w-full object-cover h-full">
          </div>
                        </div>
                        <button class="buy-button ${
                          isFirst ? '' : 'secondary'
                        }" data-product-index="${productIndex}">
                            Kaufen
                        </button>
                    </div>
                `;
        })
        .join('');

      // 添加购买按钮事件监听
      this.addBuyButtonListeners();
    }

    // 渲染比较表格
    renderComparisonTable() {
      const container = document.getElementById('comparison-table');
      if (!container) return;

      // 规格项目的键名
      const specKeys = [
        'totalOutput',
        'singleOutput',
        'ports',
        'fastCharging',
        'laptopCompatible',
        'input',
        'usbC1',
        'usbC2',
        'usbC3',
        'usbC4',
        'usbC5',
        'usbA',
        'size',
        'weight',
      ];

      // 桌面端：显示3列产品
      const desktopProducts = this.selectedProducts.slice(0, 3);
      // 移动端：显示2列产品
      const mobileProducts = this.selectedProducts.slice(0, 2);

      container.innerHTML = specKeys
        .map((specKey) => {
          return `
                    <div class="spec-row">
                        <!-- 移动端布局：2列 -->
                        <div class="block md:hidden">
                            <div class="grid grid-cols-2 gap-4">
                                ${mobileProducts
                                  .map((productIndex, index) => {
                                    const product = this.products[productIndex];
                                    const specData = product.specs[specKey];

                                    // 处理 null 值
                                    if (!specData) {
                                      return `
                                                <div class="spec-card">
                                                    <div class="flex items-center mb-3 spec-card-inner h-full">
                                                        <div class="flex-1 flex flex-col items-center justify-center">
                                                            <div class="spec-value">—</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            `;
                                    }

                                    return `
                                            <div class="spec-card">
                                                <div class="flex items-center mb-3 spec-card-inner">
                                                    ${
                                                      specData.icon
                                                        ? `<div class="icon-container">${specData.icon}</div>`
                                                        : ''
                                                    }
                                                    <div class="flex-1">
                                                        ${
                                                          specData.title
                                                            ? `<h3 class="spec-label">${specData.title}</h3>`
                                                            : ''
                                                        }
                                                        ${
                                                          specData.value
                                                            ? `<div class="spec-value">${specData.value}</div>`
                                                            : ''
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        `;
                                  })
                                  .join('')}
                            </div>
                        </div>
                        
                        <!-- 桌面端布局：3列 -->
                        <div class="hidden md:grid grid-cols-3 gap-[20px]">
                            ${desktopProducts
                              .map((productIndex, index) => {
                                const product = this.products[productIndex];
                                const specData = product.specs[specKey];

                                // 处理 null 值
                                if (!specData) {
                                  return `
                                            <div class="spec-card spec-card-desktop px-[40px]">
                                                <div class="spec-card-inner flex items-center h-full">
                                                    <div class="flex-1 flex flex-col items-center justify-center">
                                                        <div class="spec-value">—</div>
                                                    </div>
                                                </div>
                                            </div>
                                        `;
                                }

                                return `
                                        <div class="spec-card spec-card-desktop px-[40px]">
                                            <div class="spec-card-inner flex items-center">
                                                ${
                                                  specData.icon
                                                    ? `<div class="icon-container">${specData.icon}</div>`
                                                    : ''
                                                }
                                                <div class="flex-1">
                                                    ${
                                                      specData.title
                                                        ? `<h3 class="spec-label">${specData.title}</h3>`
                                                        : ''
                                                    }
                                                    ${
                                                      specData.value
                                                        ? `<div class="spec-value">${specData.value}</div>`
                                                        : ''
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    `;
                              })
                              .join('')}
                        </div>
                    </div>
                `;
        })
        .join('');
    }

    // 添加购买按钮事件监听
    addBuyButtonListeners() {
      document.querySelectorAll('.buy-button').forEach((button) => {
        button.addEventListener('click', (e) => {
          const productIndex = parseInt(e.target.dataset.productIndex);
          const product = this.products[productIndex];
          // 这里可以添加实际的购买逻辑
          window.open(product.href, '_blank');
        });
      });
    }

    // 渲染所有组件
    renderAll() {
      this.renderProductSelector();
      this.renderProductImages();
      this.renderComparisonTable();
    }

    // 防抖函数
    debounce(func, wait) {
      let timeout;
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    }

    closeModal() {
      if (!this.isOpen) return;

      this.isOpen = false;

      // 清理resize事件监听器
      if (this.handleResize) {
        window.removeEventListener('resize', this.handleResize);
        this.handleResize = null;
      }

      // 添加隐藏动画
      this.modal.classList.add('hide');
      this.modal.classList.remove('show');

      // 恢复背景滚动和之前的滚动位置
      document.body.classList.remove('modal-open');
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      
      // 恢复滚动位置
      if (typeof this.scrollPosition === 'number') {
        window.scrollTo(0, this.scrollPosition);
        this.scrollPosition = null;
      }

      // 动画结束后隐藏弹窗并恢复specs容器位置
      setTimeout(() => {
        if (!this.isOpen) {
          // 确保在动画期间没有重新打开
          this.modal.style.display = 'none';
          this.modal.classList.remove('hide');

          // 将specs容器移回原位置
          if (this.specsContainer && this.originalParent) {
            this.originalParent.appendChild(this.specsContainer);
          }
        }
      }, 300);

      // 恢复导航状态（回到Overview）
      this.updateNavState('overview');

      console.log('Specs modal closed');
    }

    updateNavState(activeSection) {
      // 更新导航链接的active状态
      this.navLinks.forEach((link) => {
        link.classList.remove('active');

        const href = link.getAttribute('href');
        if (
          (activeSection === 'specifications' &&
            link.classList.contains('specs-modal-btn')) ||
          (activeSection === 'overview' && href === '#overview')
        ) {
          link.classList.add('active');
        }
      });

      // 同时处理所有 specs-modal-btn 按钮的激活状态
      const specsButtons = document.querySelectorAll('.specs-modal-btn');
      specsButtons.forEach((button) => {
        if (activeSection === 'specifications') {
          button.classList.add('active');
        } else {
          button.classList.remove('active');
        }
      });
    }

    adjustModalPosition() {
      // 在窗口大小变化时调整弹窗位置（如果需要）
      if (this.isOpen) {
        // 重置滚动位置到顶部
        const modalContent = this.modal.querySelector('.specs-modal-content');
        if (modalContent) {
          modalContent.scrollTop = 0;
        }
      }
    }

    // 公共方法：手动打开弹窗
    open() {
      this.openModal();
    }

    // 公共方法：手动关闭弹窗
    close() {
      this.closeModal();
    }

    // 公共方法：切换弹窗状态
    toggle() {
      if (this.isOpen) {
        this.closeModal();
      } else {
        this.openModal();
      }
    }

    // 公共方法：获取弹窗状态
    isModalOpen() {
      return this.isOpen;
    }

    // 销毁方法
    destroy() {
      // 移除事件监听器
      if (this.specsLinks.length > 0) {
        this.specsLinks.forEach((link) => {
          link.removeEventListener('click', this.openModal);
        });
      }

      if (this.closeBtn) {
        this.closeBtn.removeEventListener('click', this.closeModal);
      }

      this.modal.removeEventListener('click', this.closeModal);
      document.removeEventListener('keydown', this.closeModal);
      window.removeEventListener('resize', this.adjustModalPosition);

      this.navLinks.forEach((link) => {
        if (!this.specsLinks.includes(link)) {
          link.removeEventListener('click', this.closeModal);
        }
      });

      this.scrollLinks.forEach((link) => {
        if (!this.specsLinks.includes(link)) {
          link.removeEventListener('click', this.closeModal);
        }
      });

      // 恢复body状态
      document.body.classList.remove('modal-open');

      // 恢复specs容器位置
      if (this.specsContainer && this.originalParent) {
        this.originalParent.appendChild(this.specsContainer);
      }

      // 隐藏弹窗
      if (this.modal) {
        this.modal.style.display = 'none';
        this.modal.classList.remove('show', 'hide');
      }

      this.isOpen = false;
    }
  }

  // 模块实例
  let specsModalInstance = null;

  // 初始化函数
  function initSpecsModal() {
    if (!specsModalInstance) {
      specsModalInstance = new SpecsModalModule();
      window.specsModalModule = specsModalInstance;
    }
    return specsModalInstance;
  }

  function initProductLineup() {
    const productCards = document.querySelectorAll('.ug-500w-product-card');
    const productItems = document.querySelectorAll('.ug-500w-product-item');
    const cardsContainer = document.querySelector('.ug-500w-product-cards');
    const isMobile = window.innerWidth <= 768;

    console.log('ProductLineup: Initializing...', {
      isMobile,
      productCards: productCards.length,
      productItems: productItems.length,
      cardsContainer: !!cardsContainer,
    });

    let currentActiveIndex = 0;
    let swiper = null;

    // 初始化 Swiper（仅移动端）
    if (isMobile && cardsContainer) {
      console.log('ProductLineup: Initializing Swiper for mobile...');
      initSwiper();
    } else {
      console.log('ProductLineup: Desktop mode, no Swiper needed');
      // 桌面端直接设置第一个卡片为激活状态
      setActiveCard(0);
      setupPCHoverEffects(); // 添加PC端hover效果设置
    }

    // PC端hover效果设置函数
    function setupPCHoverEffects() {
      // PC 端卡片悬停效果和点击事件
      productCards.forEach((card, index) => {
        // 移除之前的事件监听器（避免重复绑定）
        card.removeEventListener('mouseenter', card._hoverHandler);
        card.removeEventListener('click', card._clickHandler);
        
        // 创建新的事件处理器
        card._hoverHandler = () => {
          setActiveCard(index);
        };
        card._clickHandler = () => {
          setActiveCard(index);
        };

        // 鼠标悬停效果
        card.addEventListener('mouseenter', card._hoverHandler);
        // 点击切换
        card.addEventListener('click', card._clickHandler);
      });
    }

    // 初始化 Swiper
    function initSwiper() {
      // 等待 Swiper 库加载完成
      if (typeof Swiper === 'undefined') {
        console.log('ProductLineup: Swiper not loaded yet, retrying...');
        setTimeout(initSwiper, 100);
        return;
      }

      console.log('ProductLineup: Creating Swiper instance...');

      swiper = new Swiper('.ug-500w-product-cards', {
        slidesPerView: 'auto',
        centeredSlides: true,
        loop: true,
        clickable: true,
        on: {
          init: function () {
            console.log('ProductLineup: Swiper initialized successfully');
            // 初始化完成后设置第一个卡片为激活状态
            const realIndex = this.realIndex;
            setActiveCard(realIndex);
            updateSlideStates(realIndex);
          },

          slideChange: function () {
            const realIndex = this.realIndex; // 使用 realIndex 获取真实索引
            console.log(
              'ProductLineup: Slide changed to real index:',
              realIndex
            );
            setActiveCard(realIndex);
            updateSlideStates(realIndex);
          },
        },
      });

      console.log('ProductLineup: Swiper instance created:', swiper);
    }

    // 更新滑动状态
    function updateSlideStates(activeIndex) {
      productCards.forEach((card, index) => {
        // 移除手动添加的 active 类，只依赖 Swiper 的内置类
        card.classList.remove('active');

        // Swiper 会自动管理 swiper-slide-active 类
        // 我们不需要手动添加或移除它
      });
    }

    // 设置激活卡片
    function setActiveCard(index) {
      if (index < 0 || index >= productCards.length) return;

      currentActiveIndex = index;
      const card = productCards[index];
      const productId = card.dataset.product;

      // 根据当前环境决定如何管理active类
      const isDesktop = window.innerWidth > 768;
      
      if (isDesktop || !swiper) {
        // 桌面端或没有Swiper时手动管理active类
        productCards.forEach((c) => c.classList.remove('active'));
        card.classList.add('active');
        console.log('ProductLineup: Setting active card (desktop mode):', index);
      }
      // 移动端有 Swiper 时，让 Swiper 自己管理激活状态

      // 更新产品展示项
      updateActiveProduct(productId);
    }

    // 更新激活的产品展示
    function updateActiveProduct(productId) {
      productItems.forEach((item) => {
        if (item.dataset.product === productId) {
          gsap.to(item, {
            opacity: 1,
            visibility: 'visible',
            duration: 0.3,
            ease: 'power2.out',
          });
          item.classList.add('active');
        } else {
          gsap.to(item, {
            opacity: 0,
            visibility: 'hidden',
            duration: 0.3,
            ease: 'power2.out',
          });
          item.classList.remove('active');
        }
      });
    }

    // 清理PC端事件监听器
    function cleanupPCHoverEffects() {
      productCards.forEach((card) => {
        if (card._hoverHandler) {
          card.removeEventListener('mouseenter', card._hoverHandler);
          card.removeEventListener('click', card._clickHandler);
          card._hoverHandler = null;
          card._clickHandler = null;
        }
      });
    }

    // 响应式处理
    function handleResize() {
      const newIsMobile = window.innerWidth <= 768;

      // 如果从桌面切换到移动端，初始化 Swiper
      if (newIsMobile && !swiper && cardsContainer) {
        console.log('ProductLineup: Switching to mobile, initializing Swiper');
        cleanupPCHoverEffects(); // 清理PC端事件
        initSwiper();
      }
      // 如果从移动端切换到桌面，销毁 Swiper
      else if (!newIsMobile && swiper) {
        console.log('ProductLineup: Switching to desktop, destroying Swiper');
        swiper.destroy(true, true);
        swiper = null;
        setupPCHoverEffects(); // 重新设置PC端hover效果
        setActiveCard(0); // 重新设置第一个为active
      }
    }

    // 监听窗口大小变化
    window.addEventListener('resize', handleResize);

    // 清理函数
    return function cleanup() {
      if (swiper) {
        swiper.destroy(true, true);
        swiper = null;
      }
      cleanupPCHoverEffects();
      window.removeEventListener('resize', handleResize);
    };
  }

  function initMaximumPower() {
    // Check if section exists before initializing
    const maximumPowerSection = document.querySelector(
      '.ug-maximum-power-container'
    );
    if (!maximumPowerSection) return;

    const isMobile = window.innerWidth <= 768;

    // 声明动画状态变量
    let specsAnimationInitialized = false;

    // Initialize fade-in animations for section elements
    initFadeInAnimations();

    // Initialize special animations for the multi-device section
    initMultiDeviceAnimations();

    // Initialize special animations for the laptop charging section
    initLaptopChargingAnimations();

    /**
     * Set up fade-in animations for maximum power section elements
     */
    function initFadeInAnimations() {
      // Title animation
      gsap.from('.ug-maximum-power-title', {
        opacity: 0,
        y: 30,
        duration: 0.8,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: '.ug-maximum-power-container',
          start: 'top 80%',
          toggleActions: 'play none none none',
        },
      });

      // Animate each feature section
      const features = document.querySelectorAll('.ug-maximum-power-feature');
      features.forEach((feature, index) => {
        gsap.from(feature, {
          opacity: 0,
          y: 30,
          duration: 0.8,
          delay: 0.2,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: feature,
            start: 'top 80%',
            toggleActions: 'play none none none',
          },
        });
      });

      // Special scroll effect for laptop-charging image
      const laptopSection = document.querySelector('.ug-maximum-power-section');
      const laptopImage = document.querySelector(
        '.ug-maximum-power-section .ug-maximum-power-image'
      );
      const specsSection = document.querySelector('.ug-maximum-power-specs');
      const footnoteSection = document.querySelector(
        '.ug-maximum-power-footnote'
      );

      if (laptopSection && laptopImage) {
        // 初始隐藏 specs 和 footnote
        if (specsSection) {
          gsap.set(specsSection, { opacity: 0, visibility: 'hidden' });
        }
        if (footnoteSection) {
          gsap.set(footnoteSection, { opacity: 0, visibility: 'hidden' });
        }

        // 创建统一的时间线
        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: laptopImage,
            start: isMobile ? 'top 55%' : 'top 30%',
            end: '+=150%', // 延长滚动距离以容纳所有动画
            pin: laptopSection,
            scrub: 1,
            anticipatePin: 1,
            pinSpacing: true,
          },
        });

        // 1. 图片缩放和位移动画
        tl.fromTo(
          laptopImage,
          {
            scale: 1.6,
            y: isMobile ? 100 : 200,
          },
          {
            scale: 1,
            y: 0,
            duration: 1,
            ease: 'power2.out',
          }
        );

        // 2. 显示 specs 区域
        if (specsSection) {
          tl.set(specsSection, { visibility: 'visible' }, '-=0.2').to(
            specsSection,
            {
              opacity: 1,
              duration: 0.5,
              ease: 'power2.out',
            },
            '-=0.2'
          );

          // 3. specs 内部元素动画
          const specs = specsSection.querySelectorAll('.ug-maximum-power-spec');
          if (specs.length > 0) {
            tl.from(
              specs,
              {
                opacity: 0,
                y: 20,
                duration: 0.6,
                stagger: 0.2,
                ease: 'power2.out',
              },
              '-=0.3'
            );
          }
        }

        // 4. 显示 footnote 区域
        if (footnoteSection) {
          tl.set(footnoteSection, { visibility: 'visible' }, '-=0.4').to(
            footnoteSection,
            {
              opacity: 1,
              duration: 0.5,
              ease: 'power2.out',
            },
            '-=0.4'
          );
        }

        // 标记动画已初始化
        specsAnimationInitialized = true;
      } else {
        // 如果元素不存在，直接初始化specs动画
        initSpecsAnimation();
      }

      // Specs动画函数（备用，用于没有laptop图片的情况）
      function initSpecsAnimation() {
        if (specsAnimationInitialized) return;
        specsAnimationInitialized = true;

        const specs = document.querySelectorAll('.ug-maximum-power-spec');
        if (specs.length > 0) {
          gsap.from(specs, {
            opacity: 0,
            y: 20,
            duration: 0.6,
            stagger: 0.2,
            ease: 'power2.out',
            scrollTrigger: {
              trigger: '.ug-maximum-power-specs',
              start: 'top 80%',
              toggleActions: 'play none none none',
            },
          });
        }
      }

      // Animate port boxes with staggered effect
      const ports = document.querySelectorAll('.ug-maximum-power-port');
      gsap.from(ports, {
        opacity: 0,
        scale: 0.9,
        duration: 0.4,
        stagger: 0.1,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: '.ug-maximum-power-ports',
          start: 'top 85%',
          toggleActions: 'play none none none',
        },
      });
    }

    /**
     * Set up animations for the multi-device section
     */
    function initMultiDeviceAnimations() {
      // Animate the 500W value with counting effect
      const totalOutput = document.querySelector(
        '.ug-maximum-power-total-output .value'
      );
      if (totalOutput) {
        // 确保初始值已设置为可解析的数字
        const initialValue = parseInt(totalOutput.textContent) || 500;
        totalOutput.textContent = '0W';

        gsap.to(totalOutput, {
          duration: 2,
          ease: 'power2.out',
          innerText: initialValue,
          snap: { innerText: 1 },
          scrollTrigger: {
            trigger: totalOutput,
            start: 'top 80%',
            toggleActions: 'play none none none',
          },
          onUpdate: function () {
            try {
              const value = Math.round(parseFloat(this.targets()[0].innerText));
              if (!isNaN(value)) {
                totalOutput.textContent = value + 'W';
              } else {
                totalOutput.textContent = initialValue + 'W';
              }
            } catch (e) {
              totalOutput.textContent = initialValue + 'W';
            }
          },
        });
      }

      // Animate the devices title with color shift
      // const devicesTitle = document.querySelector('.ug-maximum-power-devices-title');
      // if (devicesTitle) {
      //     gsap.from(devicesTitle, {
      //         color: '#ffffff',
      //         duration: 1.5,
      //         ease: 'power2.out',
      //         scrollTrigger: {
      //             trigger: devicesTitle,
      //             start: 'top 80%',
      //             toggleActions: 'play none none none'
      //         }
      //     });
      // }
    }

    /**
     * Set up animations for the laptop charging section
     */
    function initLaptopChargingAnimations() {
      // Highlight all USB-C ports with pulsing animation
      const usbPorts = document.querySelectorAll('.ug-maximum-power-port');
      if (usbPorts.length > 0) {
        usbPorts.forEach((port, index) => {
          gsap.to(port, {
            boxShadow: '0 0 10px rgba(23, 237, 177, 0.7)',
            border: '1px solid rgba(23, 237, 177, 0.7)',
            repeat: 1, // 只重复1次，确保以暗状态结束
            yoyo: true,
            duration: 1,
            delay: 0.5 + index * 0.2, // 每个端口有不同的延迟，形成层次感
            ease: 'power2.inOut',
            scrollTrigger: {
              trigger: '.ug-maximum-power-ports',
              start: 'top 80%',
              toggleActions: 'play none none none',
            },
            onComplete: () => {
              // 确保动画结束时回到初始状态（暗着的）
              gsap.set(port, {
                boxShadow: 'none',
                border: '1px solid #616883',
              });
            },
          });
        });
      }
    }

    // Handle window resize events
    window.addEventListener('resize', function () {
      // Refresh ScrollTrigger when window is resized
      ScrollTrigger.refresh();
    });
  }

  class SimpleAppleTextMaskEffect {
    constructor() {
      this.maskText = document.querySelector('.mask-text');
      this.quadrantContainer = document.querySelector('.quadrant-container');
      this.chipContent = document.querySelector('.chip-content');
      this.section = document.querySelector('.subsection-chip');
      this.ganInfinityContainer = document.querySelector(
        '.ug-gan-infinity-container'
      );

      this.init();
    }

    init() {
      this.setupScrollObserver();
      this.setupResizeObserver();
    }

    setupScrollObserver() {
      // 使用节流函数优化滚动性能
      const throttledHandleScroll = throttle(() => {
        this.handleScroll();
      }, 16); // 约60fps

      window.addEventListener('scroll', throttledHandleScroll, {
        passive: true,
      });

      // 初始调用
      this.handleScroll();
    }

    setupResizeObserver() {
      // 添加窗口大小变化监听，确保移动端/桌面端切换时重新计算
      const debouncedResize = debounce(() => {
        this.handleScroll(); // 重新计算当前滚动位置的动画状态
      }, 250);

      window.addEventListener('resize', debouncedResize);
    }

    handleScroll() {
      const scrollY = window.scrollY;
      const windowHeight = window.innerHeight;

      // 获取section的位置信息
      const sectionRect = this.section.getBoundingClientRect();
      const sectionTop = scrollY + sectionRect.top;

      // 计算滚动进度
      const animationStart = sectionTop + windowHeight;
      const animationEnd = sectionTop + windowHeight * 2.5;
      const animationProgress = this.clamp(
        (scrollY - animationStart) / (animationEnd - animationStart),
        0,
        1
      );

      // 内容显示进度
      const contentStart = sectionTop + windowHeight * 2.4;
      const contentProgress = this.clamp(
        (scrollY - contentStart) / (windowHeight * 0.1),
        0,
        1
      );

      // 应用变换
      this.applyTransforms(animationProgress, contentProgress);
    }

    applyTransforms(progress, contentProgress) {
      // 检测是否为移动端
      const isMobile = window.innerWidth <= 768;

      // 根据设备类型设置最终缩放值
      const finalScale = isMobile ? 1.8 : 1;

      // 从80倍缩放到最终缩放值
      const scale = 80 * (1 - progress) + finalScale * progress;

      // 应用缩放变换
      if (this.maskText) {
        this.maskText.style.transform = `scale(${scale})`;
      }

      if (this.quadrantContainer) {
        this.quadrantContainer.style.transform = `scale(${scale})`;
      }

      // GaN Infinity容器的显示 - 当mask-text动画完全结束（scale达到最终值）后开始显示
      if (this.ganInfinityContainer) {
        // 当progress达到1.0时开始显示容器，使用额外的滚动距离来控制显示动画
        if (progress >= 1.0) {
          // 计算额外的滚动进度用于容器显示动画
          const scrollY = window.scrollY;
          const windowHeight = window.innerHeight;
          const sectionRect = this.section.getBoundingClientRect();
          const sectionTop = scrollY + sectionRect.top;

          // mask-text动画结束后的额外滚动距离
          const containerAnimationStart = sectionTop + windowHeight * 2.5;
          const containerAnimationEnd = sectionTop + windowHeight * 2.8;
          const containerProgress = this.clamp(
            (scrollY - containerAnimationStart) /
              (containerAnimationEnd - containerAnimationStart),
            0,
            1
          );

          this.ganInfinityContainer.style.opacity = containerProgress;
          this.ganInfinityContainer.style.transform = `translateY(${
            (1 - containerProgress) * 50
          }px)`;
        } else {
          // mask-text动画未完成时保持隐藏
          this.ganInfinityContainer.style.opacity = '0';
          this.ganInfinityContainer.style.transform = 'translateY(50px)';
        }
      }

      // 内容区域的显示
      if (this.chipContent) {
        if (contentProgress > 0) {
          this.chipContent.style.opacity = contentProgress;
          this.chipContent.style.transform = `translateY(${
            (1 - contentProgress) * 100
          }px)`;
          this.chipContent.classList.add('visible');
        } else {
          this.chipContent.style.opacity = '0';
          this.chipContent.style.transform = 'translateY(100px)';
          this.chipContent.classList.remove('visible');
        }
      }
    }

    // 限制数值范围
    clamp(value, min, max) {
      return Math.min(Math.max(value, min), max);
    }
  }

  /**
   * Initialize GaNInfinity section animations and interactions
   */
  function initGanInfinity() {
    // Check if section exists before initializing
    const ganInfinitySection = document.querySelector(
      '.ug-gan-infinity-container'
    );
    if (!ganInfinitySection) return;

    const isMobile = window.innerWidth <= 768;

    // Initialize Apple-style text mask effect
    initAppleTextMaskEffect();

    // Initialize fade-in animations for section elements
    initFadeInAnimations();

    // Initialize feature card animations
    initFeatureAnimations();

    /**
     * Initialize Apple-style text mask effect
     */
    function initAppleTextMaskEffect() {
      // Check if subsection-chip exists before initializing
      const subsectionChip = document.querySelector('.subsection-chip');
      if (subsectionChip) {
        const textMaskEffect = new SimpleAppleTextMaskEffect();
      }
    }

    /**
     * Set up fade-in animations for gan infinity section elements
     * 这些动画会在容器显示后触发
     */
    function initFadeInAnimations() {
      // Title animation - 延迟触发，等待容器显示
      gsap.fromTo(
        '.ug-gan-infinity-title',
        {
          opacity: 0,
          y: 30,
        },
        {
          opacity: 1,
          y: 0,
          duration: 0.8,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: '.ug-gan-infinity-container',
            start: 'top 40%',
            toggleActions: 'play none none none',
          },
        }
      );

      // Description animation
      gsap.fromTo(
        '.ug-gan-infinity-description',
        {
          opacity: 0,
          y: 20,
        },
        {
          opacity: 1,
          y: 0,
          duration: 0.8,
          delay: 0.2,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: '.ug-gan-infinity-container',
            start: 'top 40%',
            toggleActions: 'play none none none',
          },
        }
      );

      // Feature cards staggered animation
      const features = document.querySelectorAll('.ug-gan-infinity-feature');
      gsap.fromTo(
        features,
        {
          opacity: 0,
          y: 30,
        },
        {
          opacity: 1,
          y: 0,
          duration: 0.6,
          stagger: 0.2,
          delay: 0.4,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: '.ug-gan-infinity-container',
            start: 'top 40%',
            toggleActions: 'play none none none',
          },
        }
      );
    }

    /**
     * Set up feature card hover and animation effects
     */
    function initFeatureAnimations() {
      const features = document.querySelectorAll('.ug-gan-infinity-feature');

      features.forEach((feature, index) => {
        const icon = feature.querySelector('.ug-gan-infinity-feature-icon');

        // Icon pulse animation on scroll
        ScrollTrigger.create({
          trigger: feature,
          start: 'top 85%',
          toggleActions: 'play none none none',
          onEnter: () => {
            gsap.to(icon, {
              scale: 1.2,
              duration: 0.3,
              ease: 'power2.out',
              yoyo: true,
              repeat: 1,
            });
          },
        });
      });
    }

    // Handle window resize events
    window.addEventListener('resize', function () {
      // Refresh ScrollTrigger when window is resized
      ScrollTrigger.refresh();
    });
  }

  function initMaximumReliability() {
    // Check if section exists before initializing
    const reliabilitySection = document.querySelector(
      '.ug-maximum-reliability-container'
    );
    if (!reliabilitySection) return;

    const isMobile = window.innerWidth <= 768;

    // Initialize fade-in animations for section elements
    initFadeInAnimations();

    // Initialize feature animations
    initFeatureAnimations();

    // Initialize indicator animations
    initIndicatorAnimations();

    // Initialize feature click interactions (PC only)
    if (!isMobile) {
      initFeatureInteractions();
    }

    /**
     * Set up fade-in animations for reliability section elements
     */
    function initFadeInAnimations() {
      // Title animation
      gsap.fromTo(
        '.ug-maximum-reliability-title',
        {
          opacity: 0,
          y: 50,
        },
        {
          opacity: 1,
          y: 0,
          duration: 1,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: '.ug-maximum-reliability-title',
            start: 'top 80%',
            toggleActions: 'play none none none',
          },
        }
      );

      // Main content animation
      gsap.fromTo(
        '.ug-maximum-reliability-main',
        {
          opacity: 0,
          y: 60,
        },
        {
          opacity: 1,
          y: 0,
          duration: 1.2,
          delay: 0.2,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: '.ug-maximum-reliability-main',
            start: 'top 80%',
            toggleActions: 'play none none none',
          },
        }
      );

      // Mobile feature blocks animation
      if (isMobile) {
        const mobileFeatures = document.querySelectorAll(
          '.ug-maximum-reliability-feature-mobile'
        );
        gsap.fromTo(
          mobileFeatures,
          {
            opacity: 0,
            y: 30,
          },
          {
            opacity: 1,
            y: 0,
            duration: 0.8,
            stagger: 0.2,
            ease: 'power2.out',
            scrollTrigger: {
              trigger: '.ug-maximum-reliability-feature-mobile',
              start: 'top 85%',
              toggleActions: 'play none none none',
            },
          }
        );

        const mobileImages = document.querySelectorAll(
          '.ug-maximum-reliability-image-mobile'
        );
        gsap.fromTo(
          mobileImages,
          {
            opacity: 0,
            scale: 0.9,
          },
          {
            opacity: 1,
            scale: 1,
            duration: 0.8,
            stagger: 0.15,
            ease: 'power2.out',
            scrollTrigger: {
              trigger: '.ug-maximum-reliability-image-mobile',
              start: 'top 85%',
              toggleActions: 'play none none none',
            },
          }
        );
      }
    }

    /**
     * Set up feature animations
     */
    function initFeatureAnimations() {
      if (!isMobile) {
        // PC feature animations
        const features = document.querySelectorAll(
          '.ug-maximum-reliability-feature'
        );

        features.forEach((feature, index) => {
          gsap.fromTo(
            feature,
            {
              opacity: 0,
              x: 30,
            },
            {
              opacity: 1,
              x: 0,
              duration: 0.8,
              delay: index * 0.2,
              ease: 'power2.out',
              scrollTrigger: {
                trigger: feature,
                start: 'top 85%',
                toggleActions: 'play none none none',
              },
            }
          );
        });

        // Animate the divider line (pseudo-element)
        const contentInner = document.querySelector(
          '.ug-maximum-reliability-feature-content-inner'
        );
        if (contentInner) {
          ScrollTrigger.create({
            trigger: contentInner,
            start: 'top 85%',
            toggleActions: 'play none none none',
            onEnter: () => {
              setTimeout(() => {
                contentInner.classList.add('animated');
              }, 500); // 0.5s delay to match original divider animation
            },
          });
        }
      }
    }

    /**
     * Set up indicator animations
     */
    function initIndicatorAnimations() {
      const indicators = document.querySelectorAll(
        '.ug-maximum-reliability-indicator'
      );

      indicators.forEach((indicator) => {
        // Pulse animation for indicator icon
        const icon = indicator.querySelector(
          '.ug-maximum-reliability-indicator-icon'
        );
        if (icon) {
          gsap.to(icon, {
            scale: 1.1,
            duration: 1,
            ease: 'power2.inOut',
            yoyo: true,
            repeat: -1,
          });
        }

        // Fade in indicator on scroll
        gsap.fromTo(
          indicator,
          {
            opacity: 0,
            y: 20,
          },
          {
            opacity: 1,
            y: 0,
            duration: 0.6,
            ease: 'power2.out',
            scrollTrigger: {
              trigger: indicator,
              start: 'top 90%',
              toggleActions: 'play none none none',
            },
          }
        );
      });
    }

    /**
     * Set up feature click interactions for PC
     */
    function initFeatureInteractions() {
      const features = document.querySelectorAll(
        '.ug-maximum-reliability-feature'
      );
      const images = document.querySelectorAll('.ug-maximum-reliability-image');

      if (features.length === 0 || images.length === 0) return;

      // Set initial state - hide all images except the first one
      images.forEach((img, index) => {
        if (index === 0) {
          img.style.opacity = '1';
          img.style.zIndex = '2';
        } else {
          img.style.opacity = '0';
          img.style.zIndex = '1';
        }
        img.style.transition = 'opacity 0.4s ease-in-out';
      });

      // Add click event listeners to features
      features.forEach((feature, index) => {
        feature.addEventListener('click', function () {
          // Remove active class from all features
          features.forEach((f) => f.classList.remove('active'));

          // Add active class to clicked feature
          this.classList.add('active');

          // Switch images - show corresponding image
          images.forEach((img, imgIndex) => {
            if (imgIndex === index) {
              img.style.opacity = '1';
              img.style.zIndex = '2';
            } else {
              img.style.opacity = '0';
              img.style.zIndex = '1';
            }
          });
        });

        // Add cursor pointer style
        feature.style.cursor = 'pointer';
      });
    }

    // Handle window resize events
    window.addEventListener('resize', function () {
      // Refresh ScrollTrigger when window is resized
      ScrollTrigger.refresh();
    });
  }

  function initElevenLevelProtection() {
    // Check if section exists before initializing
    const protectionSection = document.querySelector(
      '.ug-eleven-level-protection-container'
    );
    if (!protectionSection) return;

    const isMobile = window.innerWidth <= 768;

    // Initialize fade-in animations for section elements
    initFadeInAnimations();

    // Initialize background image scroll effect
    initBackgroundImageEffect();

    // Initialize item animations (only if no background image effect)
    const bgInner = document.querySelector(
      '.ug-eleven-level-protection-bg-inner'
    );
    if (!bgInner) {
      initItemAnimations();
    }

    /**
     * Set up background image scroll effect
     */
    function initBackgroundImageEffect() {
      const bgInner = document.querySelector(
        '.ug-eleven-level-protection-bg-inner'
      );
      const protectionContainer = document.querySelector(
        '.ug-eleven-level-protection-container'
      );
      const title = document.querySelector('.ug-eleven-level-protection-title');
      const content = document.querySelector(
        '.ug-eleven-level-protection-content'
      );

      if (bgInner && protectionContainer) {
        // 初始隐藏标题和内容
        if (title) {
          gsap.set(title, { opacity: 0, visibility: 'hidden' });
        }
        if (content) {
          gsap.set(content, { opacity: 0, visibility: 'hidden' });
        }

        // 创建统一的时间线
        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: bgInner,
            start: isMobile ? 'top 20%' : 'top 10%',
            end: '+=100%', // 只需要容纳背景图片动画
            pin: protectionContainer, // pin 整个容器
            scrub: 1, // 与滚动同步
            anticipatePin: 1,
            pinSpacing: true,
          },
        });

        // 1. 背景图片缩放和位移动画
        tl.fromTo(
          bgInner,
          {
            scale: 2,
            y: isMobile ? 150 : 300,
          },
          {
            scale: 1,
            y: 0,
            duration: 1,
            ease: 'none',
          }
        );

        // 2. 标题动画 - 在背景动画80%完成时开始
        if (title) {
          tl.fromTo(
            title,
            { opacity: 0, y: 50, visibility: 'visible' },
            {
              opacity: 1,
              y: 0,
              duration: 0.3,
              ease: 'none',
            },
            0.8
          );
        }

        // 3. 内容动画 - 在背景动画90%完成时开始（整体动画，不包含内部元素的复杂效果）
        if (content) {
          tl.fromTo(
            content,
            { opacity: 0, y: 30, visibility: 'visible' },
            {
              opacity: 1,
              y: 0,
              duration: 0.3,
              ease: 'none',
            },
            0.9
          );
        }
      }
    }

    /**
     * Set up fade-in animations for protection section elements
     */
    function initFadeInAnimations() {
      // 注意：标题动画现在在 initBackgroundImageEffect 中处理

      // Background elements animation (仅在没有背景图片动画时执行)
      const bgInner = document.querySelector(
        '.ug-eleven-level-protection-bg-inner'
      );
      if (!bgInner) {
        // 如果没有背景图片，则执行原有的背景动画
        gsap.fromTo(
          '.ug-eleven-level-protection-bg',
          {
            opacity: 0,
            scale: 1.1,
          },
          {
            opacity: 1,
            scale: 1,
            duration: 1.5,
            ease: 'power2.out',
            scrollTrigger: {
              trigger: '.ug-eleven-level-protection-container',
              start: 'top 70%',
              toggleActions: 'play none none none',
            },
          }
        );
      }

      // Blur effect animation
      if (!isMobile) {
        gsap.fromTo(
          '.ug-eleven-level-protection-blur',
          {
            opacity: 0,
            scale: 0.5,
          },
          {
            opacity: 1,
            scale: 1,
            duration: 2,
            ease: 'power2.out',
            scrollTrigger: {
              trigger: '.ug-eleven-level-protection-container',
              start: 'top 60%',
              toggleActions: 'play none none none',
            },
          }
        );
      }
    }

    /**
     * Set up protection item animations
     */
    function initItemAnimations() {
      const items = document.querySelectorAll(
        '.ug-eleven-level-protection-item'
      );

      if (isMobile) {
        // Mobile: Simple fade-in from bottom
        gsap.fromTo(
          items,
          {
            opacity: 0,
            y: 30,
          },
          {
            opacity: 1,
            y: 0,
            duration: 0.6,
            stagger: 0.1,
            ease: 'power2.out',
            scrollTrigger: {
              trigger: '.ug-eleven-level-protection-grid',
              start: 'top 85%',
              toggleActions: 'play none none none',
            },
          }
        );
      } else {
        // PC: Staggered animation based on row structure
        const firstRowItem = document.querySelector(
          '.ug-eleven-level-protection-item.first'
        );
        const smallItems = document.querySelectorAll(
          '.ug-eleven-level-protection-item.small'
        );

        // Animate first row item
        if (firstRowItem) {
          gsap.fromTo(
            firstRowItem,
            {
              opacity: 0,
              y: 40,
              scale: 0.9,
            },
            {
              opacity: 1,
              y: 0,
              scale: 1,
              duration: 0.8,
              delay: 0,
              ease: 'power2.out',
              scrollTrigger: {
                trigger: '.ug-eleven-level-protection-grid',
                start: 'top 85%',
                toggleActions: 'play none none none',
              },
            }
          );

          // Icon animation for first item
          const firstIcon = firstRowItem.querySelector(
            '.ug-eleven-level-protection-icon'
          );
          if (firstIcon) {
            gsap.fromTo(
              firstIcon,
              {
                rotation: -10,
                scale: 0.8,
              },
              {
                rotation: 0,
                scale: 1,
                duration: 0.6,
                delay: 0.3,
                ease: 'back.out(1.7)',
                scrollTrigger: {
                  trigger: '.ug-eleven-level-protection-grid',
                  start: 'top 85%',
                  toggleActions: 'play none none none',
                },
              }
            );
          }
        }

        // Animate small items
        smallItems.forEach((item, index) => {
          const delay = index * 0.1 + 0.2;
          gsap.fromTo(
            item,
            {
              opacity: 0,
              y: 40,
              scale: 0.9,
            },
            {
              opacity: 1,
              y: 0,
              scale: 1,
              duration: 0.8,
              delay: delay,
              ease: 'power2.out',
              scrollTrigger: {
                trigger: '.ug-eleven-level-protection-grid',
                start: 'top 85%',
                toggleActions: 'play none none none',
              },
            }
          );

          // Icon animation
          const icon = item.querySelector('.ug-eleven-level-protection-icon');
          if (icon) {
            gsap.fromTo(
              icon,
              {
                rotation: -10,
                scale: 0.8,
              },
              {
                rotation: 0,
                scale: 1,
                duration: 0.6,
                delay: delay + 0.3,
                ease: 'back.out(1.7)',
                scrollTrigger: {
                  trigger: '.ug-eleven-level-protection-grid',
                  start: 'top 85%',
                  toggleActions: 'play none none none',
                },
              }
            );
          }
        });

        // Add parallax effect for decoration
        const decoration = document.querySelector(
          '.ug-eleven-level-protection-decoration'
        );
        if (decoration) {
          gsap.to(decoration, {
            y: '-20%',
            ease: 'none',
            scrollTrigger: {
              trigger: '.ug-eleven-level-protection-container',
              start: 'top bottom',
              end: 'bottom top',
              scrub: 1,
            },
          });
        }
      }

      // Clear hover transform after animation completes
      setTimeout(() => {
        gsap.set(items, { clearProps: 'transform' });
      }, 2000);
    }

    // Handle window resize events
    window.addEventListener('resize', function () {
      // Refresh ScrollTrigger when window is resized
      ScrollTrigger.refresh();
    });
  }

  function initCompatibility() {
    // Check if section exists before initializing
    const compatibilitySection = document.querySelector(
      '.ug-compatibility-container'
    );
    if (!compatibilitySection) return;

    const isMobile = window.innerWidth <= 768;

    // Initialize fade-in animations for section elements
    initFadeInAnimations();

    // Initialize showcase animations
    initShowcaseAnimations();

    /**
     * Set up fade-in animations for compatibility section elements
     */
    function initFadeInAnimations() {
      // Title animation
      gsap.fromTo(
        '.ug-compatibility-title',
        {
          opacity: 0,
          y: 50,
        },
        {
          opacity: 1,
          y: 0,
          duration: 1,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: '.ug-compatibility-title',
            start: 'top 80%',
            toggleActions: 'play none none none',
          },
        }
      );

      // Subtitle animation
      gsap.fromTo(
        '.ug-compatibility-subtitle',
        {
          opacity: 0,
          y: 30,
        },
        {
          opacity: 1,
          y: 0,
          duration: 0.8,
          delay: 0.2,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: '.ug-compatibility-text-section',
            start: 'top 80%',
            toggleActions: 'play none none none',
          },
        }
      );

      // Description animation
      gsap.fromTo(
        '.ug-compatibility-description',
        {
          opacity: 0,
          y: 20,
        },
        {
          opacity: 1,
          y: 0,
          duration: 0.8,
          delay: 0.4,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: '.ug-compatibility-text-section',
            start: 'top 80%',
            toggleActions: 'play none none none',
          },
        }
      );

      // Showcase animation
      gsap.fromTo(
        '.ug-compatibility-showcase',
        {
          opacity: 0,
          y: 40,
          scale: 0.95,
        },
        {
          opacity: 1,
          y: 0,
          scale: 1,
          duration: 1,
          delay: 0.6,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: '.ug-compatibility-showcase',
            start: 'top 85%',
            toggleActions: 'play none none none',
          },
        }
      );
    }

    /**
     * Set up showcase specific animations
     */
    function initShowcaseAnimations() {
      const showcase = document.querySelector('.ug-compatibility-showcase');
      const overlay = document.querySelector('.ug-compatibility-overlay');

      if (!showcase) return;

      // 移除图片视差效果 - 让图片保持静止
      // const image = document.querySelector('.ug-compatibility-image');
      // if (image) {
      //     gsap.fromTo(image,
      //         {
      //             y: '0%'
      //         },
      //         {
      //             y: '-10%',
      //             ease: 'none',
      //             scrollTrigger: {
      //                 trigger: showcase,
      //                 start: 'top bottom',
      //                 end: 'bottom top',
      //                 scrub: 1
      //             }
      //         }
      //     );
      // }

      // Overlay text animation
      if (overlay) {
        const number = overlay.querySelector('.ug-compatibility-number');
        const powerText = overlay.querySelector('.ug-compatibility-power-text');
        const devicesText = overlay.querySelector(
          '.ug-compatibility-devices-text'
        );

        // PC端：完整的文字动画 + 数字自增
        if (!isMobile) {
          // Staggered animation for overlay elements
          gsap.fromTo(
            [number, powerText, devicesText],
            {
              opacity: 0,
              y: 20,
            },
            {
              opacity: 1,
              y: 0,
              duration: 0.8,
              stagger: 0.1,
              delay: 1,
              ease: 'power2.out',
              scrollTrigger: {
                trigger: showcase,
                start: 'top 85%',
                toggleActions: 'play none none none',
              },
            }
          );
        }

        // 数字自增动画（PC端和移动端都执行）
        if (number) {
          const countUpAnimation = { value: 0 };
          gsap.fromTo(
            countUpAnimation,
            {
              value: 0,
            },
            {
              value: 1000,
              duration: 2,
              delay: isMobile ? 0.8 : 1.2, // 移动端稍早开始
              ease: 'power2.out',
              onUpdate: function () {
                number.textContent = Math.round(countUpAnimation.value) + '+';
              },
              scrollTrigger: {
                trigger: showcase,
                start: isMobile ? 'top 90%' : 'top 85%', // 移动端稍早触发
                toggleActions: 'play none none none',
              },
            }
          );
        }
      }

      // Hover effect for showcase (PC only)
      if (!isMobile && showcase) {
        showcase.addEventListener('mouseenter', () => {
          gsap.fromTo(
            showcase,
            {
              scale: 1,
            },
            {
              scale: 1.02,
              duration: 0.3,
              ease: 'power2.out',
            }
          );
        });

        showcase.addEventListener('mouseleave', () => {
          gsap.fromTo(
            showcase,
            {
              scale: 1.02,
            },
            {
              scale: 1,
              duration: 0.3,
              ease: 'power2.out',
            }
          );
        });
      }
    }

    // Handle window resize events
    window.addEventListener('resize', function () {
      // Refresh ScrollTrigger when window is resized
      ScrollTrigger.refresh();
    });
  }

  function throttle(func, limit) {
    let inThrottle;
    return function () {
      const args = arguments;
      const context = this;
      if (!inThrottle) {
        func.apply(context, args);
        inThrottle = true;
        setTimeout(() => (inThrottle = false), limit);
      }
    };
  }

  /**
   * 防抖函数 - 延迟执行函数，如果在延迟期间再次调用则重新计时
   * @param {Function} func - 要执行的函数
   * @param {number} delay - 延迟时间(毫秒)
   * @returns {Function} - 防抖处理后的函数
   */
  function debounce(func, delay) {
    let timer;
    return function () {
      const context = this;
      const args = arguments;
      clearTimeout(timer);
      timer = setTimeout(() => func.apply(context, args), delay);
    };
  }

  /**
   * ScrollTrigger刷新
   * 用于在页面滚动时刷新ScrollTrigger
   */
  function setupScrollRefresh() {
    // 只在窗口大小变化时刷新 ScrollTrigger，移除滚动时的刷新
    const debouncedRefresh = debounce(function () {
      ScrollTrigger.refresh();
    }, 250);

    window.addEventListener('resize', debouncedRefresh);

    // 移除滚动时的刷新逻辑，因为这会导致性能问题
    // 移动设备初始化时做一次检测即可
    if (window.innerWidth <= 768) {
      setTimeout(function () {
        ScrollTrigger.refresh();
      }, 500);
    }
  }

  function handleResize() {
    // 可以在这里添加窗口大小变化时的额外逻辑
    // 由于使用了纯CSS的响应式方案，这里不需要额外处理
  }
})();
